
    <div *ngIf="translatorAvailable" class="language-selector-container">
      <select [(ngModel)]="selectedLanguage" (change)="languageChanged()" [disabled]="isLoading">
        <option *ngFor="let language of languages" [value]="language.key">
          {{ language.value }}
        </option>
      </select>
      
      <div *ngIf="isLoading" class="spinner"></div>
    </div>
  